import React from "react";
import JsonEditor from "../../../../components/JsonEditor/JsonEditor";
import { useLanguage } from "../../../../LanguageProvider";
import "./Body.css";
export default function Body({ code, setCode, result }) {
  const { getTranslation } = useLanguage();
  return (
    <div className="body-main-container">
      <div className="body-left-section">
        <JsonEditor code={code} setCode={setCode} />
      </div>

      <div className="body-right-section">
        {result ? (
          <JsonEditor code={result} setCode={setCode} readOnly={true} />
        ) : (
          <div className="see-response-container">
            <p>{getTranslation("seeResponse")}</p>
          </div>
        )}
      </div>
    </div>
  );
}
